import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { categoryActions as actions } from '../../../actions';
import AuthService from '../../../services/auth.service';
import LoadingListener from '../../../helpers/loadingListener';
import { history } from '../../../helpers';
import '../../../content/css/PickContractType.css';
import ContractTypePicker from '../../Misc/ContractTypePicker';

class ThemeSelectUserView extends Component {
    constructor(props) {
        super(props);

        this.authService = new AuthService();
        this.loadingListener = new LoadingListener([], true);
    }

    handleThemeSelect = (type, hasChildren) => {
        if (!hasChildren)
            history.push(`/themes/${type.contractType}`);
    }

    render() {
        return (
            <div className="theme-select-user-view">
                <ContractTypePicker
                    title="Themes"
                    subtitle="Select a theme to view details about it."
                    onSelect={this.handleThemeSelect}
                />
            </div>
        );
    }
}

export default connect(
    state => state.category,
    dispatch => bindActionCreators(actions, dispatch)
)(ThemeSelectUserView);


// WEBPACK FOOTER //
// ./src/components/CategoryView/UserView/ThemeSelectUserView.js